import { toolCallOutputUploadPath } from "./apiPaths";
import { apiUrl } from "./tenantOrigin";

export async function uploadToolCallOutput(args: {
  chatId: string;
  entryId: string;
  output: unknown;
}): Promise<string> {
  const response = await fetch(`${apiUrl()}${toolCallOutputUploadPath()}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(args),
  });
  if (!response.ok) throw new Error(await response.text());
  return ((await response.json()) as { id: string }).id;
}
